import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AlertController, Platform} from 'ionic-angular';
import {ReducceService} from '../../shared/services/reducce.service';


@Component({
  selector: 'core-reducce-payment-loader',
  templateUrl: './reducce-payment-loader.component.html'
})
export class ReduccePaymentLoaderComponent implements OnInit, OnDestroy {

  @Input() orderId: number;
  @Input() beneficiaireId: number;
  @Input() paymentStatus: string;
  @Input() isWorkflow: boolean;
  @Input() isSubvention: boolean;
  @Input() onlyPopupInfo: boolean;
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter<any>();
  private checkTimeout: any;
  private count = 0;
  private MAXCOUNT = 3;
  private backbuttonSubscription: any;

  public constructor(private alertCtrl: AlertController, private reducceService: ReducceService, private platform: Platform) {
  }

  ngOnInit(): void {
    if (!this.onlyPopupInfo) {
      this.checkCommande();
    }
    this.backbuttonSubscription = this.platform.registerBackButtonAction(() => {
      this.close();
    })
  }

  ngOnDestroy(): void {
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }
    if(this.backbuttonSubscription) {
      this.backbuttonSubscription();
    }
  }

  checkCommande() {
    let cancel = false;
    let context = '';
    if (this.paymentStatus) {
      switch (this.paymentStatus) {
        case 'error':
          cancel = true;
          context = 'REFUSED';
          break;
        case 'cancel':
          cancel = true;
          context = 'ABORT';
          break;
      }
    }

    this.reducceService.checkCommande(this.orderId, cancel, context ).subscribe(res => {
      if (res) {
        if (res.statutAdministratif == 'VAL') {
          // je relance le check dans 10s car le statut est toujours en attente.
          this.relaunchCheck();
        } else {
          // le statut de la commande a été modifié, je dirige vers le détail de la commande
          this.closeEmitter.emit('success');
        }
      } else {
        this.relaunchCheck();
      }
    }, error => {
      this.relaunchCheck();
    })
  }

  relaunchCheck() {
    if (this.count < this.MAXCOUNT) {
      this.count++;
      this.checkTimeout = setTimeout(() => {
        this.checkCommande()
      }, 5000)
    } else {
      this.close();
    }

  }

  close() {
    this.closeEmitter.emit('dismiss');
  }
}



// WEBPACK FOOTER //
// ./src/core/reducce-payment-loader/reducce-payment-loader.component.ts